import { render } from "./PartiesList.vue?vue&type=template&id=48328a5b"
import script from "./PartiesList.vue?vue&type=script&lang=js"
export * from "./PartiesList.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__